/**
 * @author sradha shet
 */
import { UPDATE_SM_BUSINESS_HOUR_TEMPLATE ,UPDATE_SM_DONE} from '../../common/actions';
import { HiverAxios, unsavedChanges ,showMessage, sendTrackingEvent} from 'h-commons';
import { toast } from 'react-toastify';
import {getAutoResp} from '../../autoResponder/actions';
const SM_ROOT = '/gx/api/sm';


export const linkBusinessHourToSm = (sm,smid,params) => 
    dispatch => {
        const url = `${SM_ROOT}/${smid}/businesshours`;
        let message = 'Business Hour template sucessfully linked to Shared Mailbox';
    return HiverAxios({
        url: url,
        type: 'POST',
        params:params,
        callback: (response) => {
           dispatch(unsavedChanges(false));
            const smData = response.data
            if (smData) {
               dispatch({
                   type: UPDATE_SM_DONE,
                   payload:smData
                });
                dispatch(getAutoResp(smid));
                if(params.id == 0){
                    message = 'Business Hour template sucessfully Unlinked from Shared Mailbox';
                }
                showMessage({
                    message:message,
                    type:'success'
                });
                sendTrackingEvent('appliedBH');
            } else {
                dispatch({
                    type: UPDATE_SM_BUSINESS_HOUR_TEMPLATE
                });
                showMessage({
                    message:'Failed to link template',
                    type:'error'
                });
            }
               
        },
        onfail: (err) => {
            dispatch(unsavedChanges(false));
            showMessage({
                message:'Failed to link template',
                type:'error'
            });
        }
    });
}

